import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Selection } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import { GroupDelegate } from '@leverege/molten-core';
import Model from "./GroupClusterModel.js";
import GroupClusterRenderer from "./GroupClusterRenderer.js";
import useGroupClusterData from "./hooks/useGroupClusterData.js";
import { jsx as _jsx } from "react/jsx-runtime";
const QUERY_NAME = 'group_cluster';
function GroupClusterDataLayer(props) {
  const {
    attribute,
    delegate,
    filters,
    items: pItems,
    map,
    relationship,
    selected,
    model
  } = props;
  const [filter, setFilter] = useState();
  const onFilterChange = useCallback(({
    data,
    value
  }) => {
    setFilter(value);
  }, []);
  const {
    centers
  } = useGroupClusterData({
    attribute,
    delegate,
    filter,
    onFilterChange,
    relationship,
    selected,
    filters,
    map,
    model
  });
  const items = useMemo(() => {
    const ref = delegate.getInterfaceUrl();
    const objectType = relationship.objectType;
    const groupAttribute = attribute?.source?.attribute?.metadata?.clustering?.groupAttribute;
    const attr = Attributes.getAttribute(groupAttribute, objectType);
    return pItems.map(item => {
      const nItem = {
        id: item.id,
        ref,
        type: objectType,
        data: item
      };
      const val = attr.get(item);
      if (val) {
        nItem.parent = {
          ref,
          id: val,
          type: `${objectType}-group`
        };
      }
      return nItem;
    });
  }, [pItems]);
  return /*#__PURE__*/_jsx(GroupClusterRenderer, {
    ...props,
    items: items,
    onFilterChange: onFilterChange,
    filter: filter,
    centers: centers
  });
}
function ClusterLayer(props) {
  const {
    model
  } = props;
  if (!model.visible) {
    return null;
  }
  return /*#__PURE__*/_jsx(GroupClusterDataLayer, {
    ...props
  });
}
export default function OptionalRenderer(props) {
  const {
    model,
    backupRenderer: BackupRenderer,
    overrideModel
  } = props;
  if (overrideModel?.shouldCluster === false || !Model.getShouldCluster(model) && model?.backupRenderer) {
    return /*#__PURE__*/_jsx(BackupRenderer, {
      ...props,
      model: model.backupRenderer
    });
  }
  return /*#__PURE__*/_jsx(ReduxRenderer, {
    ...props
  });
}
const ReduxRenderer = connect((state, props) => {
  const {
    relationship,
    attribute
  } = props;
  const {
    match
  } = relationship;
  const queryName = `${attribute.id}.${QUERY_NAME}`;
  const delegate = new GroupDelegate({
    relationship,
    match,
    ttl: 30000,
    queryName
  });
  return {
    selected: Selection.get(state, 'selected'),
    rollover: Selection.get(state, 'rollover'),
    mapEditing: Selection.get(state, 'mapEditing'),
    items: delegate.getList(state, {
      getAll: true,
      queryName
    })?.items || [],
    delegate
  };
})(ClusterLayer);